<template>
  <v-col :cols="block.cols" :xs="block.colsxs" :sm="block.colssm" :md="block.colsmd" :lg="block.colslg" :xl="block.colsxl" :offset="block.offset">
    <v-row style="border: 2px solid var(--v-primary-base)" class="pl-6">
      <v-col cols="4" class="font-weight-medium pl-14 pb-6 primary--text" style="font-size: 18px !important">
        {{ block.inputLabel }}
      </v-col>
      <v-col cols="12">
        <v-slider
          v-model="counter"
          class="align-center pl-4"
          :max="100"
          :min="1"
          hide-details
          ticks="always"
          tick-size="3"
          thumb-label="always"
          track-color="grey"
        >
          <!-- <template #prepend>

          </template> -->
          <template #thumb-label="{ value }">
            <span class="text--white">{{ value }}</span>
          </template>
        </v-slider>
      </v-col>
    </v-row>
    <!-- <v-row class="center primary_light white--text">

       <span class="ml-5 px-0">
        <v-text-field
          v-model="counter"
          :label="block.inputLabel"
          dense
          type="number"
          hide-details="auto"
          min="1"
        />
      </span>
    </v-row> -->
    <v-row align="center">
      <v-col cols="12" class="px-0">
        <v-expansion-panels
          v-model="panels"
          multiple
          flat
        >
          <v-expansion-panel
            v-for="n in parseInt(counter)"
            :key="'panel_' + (n-1)"
          >
            <v-expansion-panel-header
              :class="panels.includes(n-1) ? 'primary--text font-weight-bold' : 'grey--text text--darken-3 font-weight-bold' "
              style="font-size: 18px !important"
            >
              <template #actions left>
                <v-icon large class="expansionpanel-icon" color="primary">
                  mdi-chevron-down-circle
                </v-icon>
              </template>

              <span class="expansionpanel-header">
                <template v-if="form[(n-1)].name != null">
                  {{ form[(n-1)].name }}
                </template>
                <template v-else>
                  Standort {{ n }}
                </template>
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="ml-10">
              <v-row>
                <template v-for="expansionpanelBlock in block.expansionpanelComponents">
                  <component :is="expansionpanelBlock.component" :key="expansionpanelBlock.uid" v-model="form[(n-1)][expansionpanelBlock.uid]" :class="expansionpanelBlock.class" :block="expansionpanelBlock" />
                </template>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
export default {
   name: 'NExpansionpanels',
   model: {
      prop: 'form',
      event: 'update:form'
   },

   props: {
      block: {
         type: Object,
         required: true,
      },
      form: {
         type: Object,
         required: true,
      },
   },
   data () {
      return {
         panels: [
            0
         ],
         counter: 0,
      }
   },

   watch: {
      counter: function (val, oldVal) {
         val = parseInt(val)
         oldVal = (parseInt(oldVal) === this.form.length) ? parseInt(oldVal) : this.form.length
         if (val === 0) {
            this.form = []
         } else {
            if (oldVal > val) {
               this.form = this.form.slice(0, val)
            } else {
               for (let index = oldVal; index < val; index++) {
                  this.form.push(JSON.parse(JSON.stringify(this.block.default)))
               }
            }
         }
      },
      form: {
         deep: true,
         handler (val, oldVal) {
            this.$emit('update:form', this.form)
         }
      }
   },
   created () {
      this.counter = this.form.length
   },
}
</script>
